var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('DeviceTest.WebcamTest.Confirm'))}}),_vm._v(" "),_c('div',{staticClass:" py-2"},[_vm._v("\n        "+_vm._s(_vm.$t('DeviceTest.WebcamTest.Select'))),_c('select',{attrs:{"id":"camera-select","name":"camera-select"}})]),_vm._v(" "),_c('video',{attrs:{"id":"webcam-output"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aeb5d99","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeviceTestPages/videoTest.vue
// module id = null
// module chunks = 